import WidgetTypeRouter from './WidgetTypeRouter';
export default WidgetTypeRouter;



// WEBPACK FOOTER //
// ./src/components/WidgetTypeRouter/index.js